import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { stylistAPI } from '../../services/api';
import { Lock, Loader2, AlertCircle, Sparkles } from 'lucide-react';

const StylistLogin = () => {
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  
  const navigate = useNavigate();

  // Check if already logged in
  useEffect(() => {
    const token = localStorage.getItem('stylistToken');
    if (token) {
      navigate('/stylist');
    }
  }, [navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!password.trim()) return;

    setLoading(true);
    setError('');

    try {
      const response = await stylistAPI.login(password);
      if (response.success) {
        localStorage.setItem('stylistToken', response.token);
        navigate('/stylist');
      }
    } catch (err) {
      setError('Неверный пароль');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      backgroundColor: 'var(--charcoal)',
      padding: 'var(--space-xl)'
    }}>
      <div style={{
        width: '100%',
        maxWidth: '400px',
        backgroundColor: 'var(--white)',
        padding: 'var(--space-xxl)'
      }}>
        {/* Logo */}
        <div style={{ textAlign: 'center', marginBottom: 'var(--space-xxl)' }}>
          <div style={{
            display: 'inline-flex',
            alignItems: 'center',
            justifyContent: 'center',
            width: '60px',
            height: '60px',
            backgroundColor: 'var(--charcoal)',
            borderRadius: '50%',
            marginBottom: 'var(--space-l)'
          }}>
            <Sparkles size={28} style={{ color: 'var(--accent-gold)' }} />
          </div>
          <h1 style={{
            fontFamily: 'var(--font-display)',
            fontSize: '1.75rem',
            color: 'var(--black)',
            marginBottom: 'var(--space-s)'
          }}>
            Панель стилиста
          </h1>
          <p style={{
            fontFamily: 'var(--font-body)',
            fontSize: '0.875rem',
            color: 'var(--mid-gray)'
          }}>
            Управление клиентами и образами
          </p>
        </div>

        <form onSubmit={handleSubmit} data-testid="stylist-login-form">
          <div style={{ marginBottom: 'var(--space-l)' }}>
            <label style={{
              display: 'block',
              fontFamily: 'var(--font-body)',
              fontSize: '0.75rem',
              letterSpacing: '1px',
              textTransform: 'uppercase',
              color: 'var(--mid-gray)',
              marginBottom: 'var(--space-s)'
            }}>
              Пароль
            </label>
            <div style={{ position: 'relative' }}>
              <Lock 
                size={18} 
                style={{ 
                  position: 'absolute', 
                  left: '16px', 
                  top: '50%', 
                  transform: 'translateY(-50%)',
                  color: 'var(--light-gray)'
                }} 
              />
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="Введите пароль"
                data-testid="stylist-password-input"
                style={{
                  width: '100%',
                  padding: '16px 16px 16px 48px',
                  fontFamily: 'var(--font-body)',
                  fontSize: '1rem',
                  border: '1px solid var(--soft-gray)',
                  outline: 'none',
                  transition: 'border-color 300ms ease',
                  boxSizing: 'border-box'
                }}
                onFocus={(e) => e.target.style.borderColor = 'var(--accent-gold)'}
                onBlur={(e) => e.target.style.borderColor = 'var(--soft-gray)'}
              />
            </div>
          </div>

          {error && (
            <div 
              data-testid="stylist-login-error"
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: 'var(--space-s)',
                padding: 'var(--space-m)',
                backgroundColor: '#fef2f2',
                marginBottom: 'var(--space-l)'
              }}
            >
              <AlertCircle size={18} style={{ color: '#ef4444' }} />
              <span style={{
                fontFamily: 'var(--font-body)',
                fontSize: '0.875rem',
                color: '#ef4444'
              }}>
                {error}
              </span>
            </div>
          )}

          <button
            type="submit"
            disabled={loading || !password.trim()}
            data-testid="stylist-login-btn"
            style={{
              width: '100%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: 'var(--space-s)',
              padding: '18px',
              backgroundColor: loading || !password.trim() ? 'var(--light-gray)' : 'var(--charcoal)',
              color: 'var(--white)',
              border: 'none',
              fontFamily: 'var(--font-body)',
              fontSize: '0.8125rem',
              letterSpacing: '2px',
              textTransform: 'uppercase',
              cursor: loading || !password.trim() ? 'not-allowed' : 'pointer',
              transition: 'all 300ms ease'
            }}
          >
            {loading ? (
              <>
                <Loader2 size={18} style={{ animation: 'spin 1s linear infinite' }} />
                Вход...
              </>
            ) : (
              'Войти'
            )}
          </button>
        </form>
      </div>

      <style>{`
        @keyframes spin {
          from { transform: rotate(0deg); }
          to { transform: rotate(360deg); }
        }
      `}</style>
    </div>
  );
};

export default StylistLogin;
